import { useState, useEffect } from 'react'
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Row,
    Col
} from 'reactstrap'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import '../css/di.css'

// Import FOC components
import FocCreateDi from './FocCreateDi'
import FocViewDi from './FocViewDi'
import FocViewPackList from './FocViewPackList'
import FocViewInvoice from './FocViewInvoice'
import PageHeader from './utils/PageHeader'

const FocDi = () => {
    const [activeTab, setActiveTab] = useState('1')
    const userDetails = useSelector(store => store.user)

    // Default to 'View Pack List' (Tab 3) for Store Manager
    useEffect(() => {
        if (userDetails?.role === 'store_manager') {
            setActiveTab('3')
        }
    }, [userDetails?.role])

    const toggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    return (
        <div className='di-container'>
            <PageHeader
                pageName='FOC DELIVERY INSTRUCTION'
                breadcrump1='Home'
                breadcrump2='Foc Delivery Instruction'
                link='/foc_invoice_journey_start'
            />

            <div className='p-3'>
                <div className='modern-tabs-wrapper'>
                    <div className='modern-tabs-container'>
                        <Nav className='modern-nav-tabs' tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames('modern-nav-link', {
                                        active: activeTab === '1'
                                    })}
                                    onClick={() => toggle('1')}
                                >
                                    <div className='tab-content-wrapper'>
                                        <span className='tab-icon'>
                                            {userDetails?.role === 'commercial_manager' || userDetails?.role === 'store_manager' ? '👁️' : '📝'}
                                        </span>
                                        <span className='tab-text'>
                                            {userDetails?.role === 'commercial_manager' || userDetails?.role === 'store_manager'
                                                ? 'View SO'
                                                : 'Create DI'}
                                        </span>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames('modern-nav-link', {
                                        active: activeTab === '2'
                                    })}
                                    onClick={() => toggle('2')}
                                >
                                    <div className='tab-content-wrapper'>
                                        <span className='tab-icon'>👁️</span>
                                        <span className='tab-text'>View DI</span>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames('modern-nav-link', {
                                        active: activeTab === '3'
                                    })}
                                    onClick={() => toggle('3')}
                                >
                                    <div className='tab-content-wrapper'>
                                        <span className='tab-icon'>📦</span>
                                        <span className='tab-text'>View Pack List</span>
                                    </div>
                                </NavLink>
                            </NavItem>

                        </Nav>
                    </div>
                </div>
                <TabContent activeTab={activeTab} className='modern-tab-content'>
                    <TabPane tabId='1' className='fade-in'>
                        <Row>
                            <Col>
                                <FocCreateDi />
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId='2' className='fade-in'>
                        <Row>
                            <Col>
                                <FocViewDi />
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId='3' className='fade-in'>
                        <Row>
                            <Col>
                                <FocViewPackList />
                            </Col>
                        </Row>
                    </TabPane>

                </TabContent>
            </div>
        </div>
    )
}

export default FocDi
